import React, {
  useEffect,
  useState,
  forwardRef,
  useImperativeHandle,
  useRef,
} from "react";
import { useTranslation } from "react-i18next";
import StepContainer from "../stepContainer";
import SkillGoalsSelectionPage from "./skillGoalsSelectionPage";
import { saveStep } from "../../../services/profileService";
import { getUserSkillGoals } from "../../../services/profileService";
import { useDispatch, useSelector } from "react-redux";
import { profileActions } from "../../../redux/reducers/profileReducer";

const SkillGoalsSelection = forwardRef((props, ref) => {
  const { t } = useTranslation();
  const [isSkillGoalsSelection, setIsSkillGoalsSelection] = useState(null);
  const [existingData, setExistingData] = useState(null);
  const childRef = useRef(); // declare a ref for child component
  const dispatch = useDispatch();

  const existingSkillGoals = useSelector((state) => state.profile.skillGoals);

  // On step load
  useEffect(() => {
    props.setProgressValue(75);

    // Check if skill goals are already locally stored
    if (existingSkillGoals.length > 0) {
      setExistingData(existingSkillGoals);
      setIsSkillGoalsSelection(true);
    } else {
      // Make request to check if user has already selected skill goals
      getUserSkillGoals().then((res) => {
        if (res.data.length > 0) {
          setExistingData(res.data);
          setIsSkillGoalsSelection(true);
          dispatch(profileActions.setSkillGoals(res.data));
        }
      });
    }
  }, []);

  const onStepClose = async (goStepBack = false, stepCompleted = true) => {
    let data = {
      currentStep: 3,
      updatedSkillGoals: [],
      isStepCompleted: stepCompleted,
    };
    // Request to save step completion and then navigate to next step
    await saveStep(data);
    if (stepCompleted) {
      if (goStepBack) props.navigateStepBack();
      else props.navigateStepFront();
    }
  };

  useImperativeHandle(ref, () => ({
    onStepClose: (goStepBack, stepCompleted) => {
      if (childRef.current && childRef.current.onStepClose) {
        // Call child's onStepClose, if it's rendered and has onStepClose
        return childRef.current.onStepClose(goStepBack, stepCompleted);
      }

      // Otherwise, fallback to the parent's onStepClose
      return onStepClose(goStepBack, stepCompleted);
    },
  }));

  return (
    <>
      {isSkillGoalsSelection ? (
        <SkillGoalsSelectionPage
          ref={childRef}
          onBack={() => setIsSkillGoalsSelection(false)}
          navigateStepFront={props.navigateStepFront}
          navigateStepBack={props.navigateStepBack}
          setProgressValue={props.setProgressValue}
          skillProficiencyLevelsEnabled={props.skillProficiencyLevelsEnabled}
          existingData={existingData}
        />
      ) : (
        <StepContainer
          stepTitle={t("profileScreen.skillGoalsStep.confirmation.title")}
          stepDescription={t(
            "profileScreen.skillGoalsStep.confirmation.description"
          )}
          onTransparentButtonClick={onStepClose}
          transparentButtonLabel={t("profileScreen.btnNo")}
          onSecondaryButtonClick={() => setIsSkillGoalsSelection(true)}
          secondaryButtonLabel={t("profileScreen.btnYes")}
        />
      )}
    </>
  );
});

export default SkillGoalsSelection;
